"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreateCategoryGroupsPayload = void 0;
const uuid_1 = require("uuid");
const categories_1 = require("companion-app-components/flux/categories");
const categoryGroupMainTypes = [{
        name: 'Personal Income',
        type: categories_1.categoriesTypes.CategoryTypeEnum.INCOME,
        coa: categories_1.categoriesTypes.CategoryTypeEnum.INCOME,
    }, {
        name: 'Personal Expenses',
        type: categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE,
        coa: categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE,
    }, {
        name: 'Business Income',
        type: categories_1.categoriesTypes.CategoryTypeEnum.INCOME,
        coa: null,
    }, {
        name: 'Business Expenses',
        type: categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE,
        coa: null,
    }, {
        name: 'Rental Property Income',
        type: categories_1.categoriesTypes.CategoryTypeEnum.INCOME,
        coa: null,
    }, {
        name: 'Rental Property Expenses',
        type: categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE,
        coa: null,
    }];
const getCreateCategoryGroupsPayload = (allIncomeCategories, allExpenseCategories, categoryGroupListId) => {
    const payload = categoryGroupMainTypes.map(({ name, type, coa }) => {
        const data = {
            name,
            type,
            categoryGroupListId,
            isDeleted: false,
            isNotEditable: true,
            clientId: (0, uuid_1.v4)(),
        };
        if (coa === categories_1.categoriesTypes.CategoryTypeEnum.INCOME) {
            data.coas = allIncomeCategories === null || allIncomeCategories === void 0 ? void 0 : allIncomeCategories.map((categoryId) => ({
                id: categoryId,
                type: 'CATEGORY',
            }));
        }
        else if (coa === categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE) {
            data.coas = allExpenseCategories === null || allExpenseCategories === void 0 ? void 0 : allExpenseCategories.map((categoryId) => ({
                id: categoryId,
                type: 'CATEGORY',
            }));
        }
        return data;
    });
    return payload;
};
exports.getCreateCategoryGroupsPayload = getCreateCategoryGroupsPayload;
